import { createFileRoute } from "@tanstack/react-router";

import { NotFoundPage } from "#/components/ErrorPage";

export const Route = createFileRoute("/404")({
  component: NotFoundPage,
});
